<template>
  <v-data-table
    :headers="headers"
    :items="deduplicatedList"
    dense
    hide-default-footer
    multi-sort
    :sort-by="['display', 'formattedPlanDate']"
    :sort-desc="[false, true]"
  >
  </v-data-table>
</template>
<script>
export default {
  props: ["mandates"],
  data() {
    return {
      headers: [
        { text: "Mandate", value: "display" },
        { text: "Plan Date", value: "formattedPlanDate" },
        { text: "Auth End Date", value: "formattedAuthEndDate" },
      ],
    };
  },
  computed: {
    deduplicatedList() {
      var displayFields = [
        "display",
        "formattedPlanDate",
        "formattedAuthEndDate",
      ];
      const seen = new Set();
      return this.mandates.filter((record) => {
        const key = displayFields.map((f) => record[f]).join("|");
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    },
  },
};
</script>
